
interface Position { id: string; title: string; year: number; }
interface Company { id: string; name: string; period: string; secondary?: boolean; tech: string[]; positions: Position[] }

interface MiniCVSectionProps {
  cvData: Company[];
}

const PositionRow = ({ title, year }: Omit<Position, "id">) => {
  return (
    <div className="content-stretch flex gap-[10px] items-start relative shrink-0 w-full">
      <div className="content-stretch flex flex-[1_0_0] items-center justify-center min-h-px min-w-px relative">
        <p className="flex-[1_0_0] font-['Manrope:Regular',sans-serif] font-normal leading-[normal] min-h-px min-w-px relative text-[#334155] text-[12px] whitespace-pre-wrap">
          {title}
        </p>
      </div>
      <div className="content-stretch flex flex-[1_0_0] items-center justify-end min-h-px min-w-px relative self-stretch">
        <p className="font-['Manrope:Regular',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#334155] text-[12px] text-right">
          {year}
        </p>
      </div>
    </div>
  );
};

const CompanyHeader = ({ name, period, tech=[], secondary=false}: Omit<Company, "positions"|"id">) => {
  return (  
    <div className="content-stretch flex gap-[10px] items-start relative shrink-0 w-full">
      <div className={`content-stretch flex flex-col font-['Manrope:Bold',sans-serif] font-bold items-start leading-[normal] relative shrink-0 ${secondary ? 'text-[#777]' : 'text-[#0f172a]'}`}>
        <p className="relative shrink-0 text-[14px]">{name}</p>
        <p className="relative shrink-0 text-[9px]">
          {tech.join(", ")}
        </p>
      </div>
      <div className="content-stretch flex flex-[1_0_0] items-center justify-end min-h-px min-w-px relative self-stretch">
        <p className={`font-['Manrope:Regular',sans-serif] font-normal leading-[normal] relative shrink-0 ${secondary ? 'text-[#777]' : 'text-[#0f172a]'} text-[14px] text-right`}>
          {period}
        </p>
      </div>
    </div>);
}

const MiniCVSection = ({ cvData }: MiniCVSectionProps) => {
  return (
    <div className="content-stretch flex flex-col gap-[10px] items-start overflow-clip relative shrink-0 w-full">
      {cvData.map(({id, name, period, tech, secondary, positions}) => (
        <div key={id} className="content-stretch flex flex-col items-center justify-center relative shrink-0 w-full gap-[2px]">
          <CompanyHeader name={name} period={period} tech={tech} secondary={secondary} />
          {positions.map(position => (
            <PositionRow key={position.id} title={position.title} year={position.year} />
          ))}
        </div>
      ))}
      {/* ООО Герофарм */}
      {/* <div className="content-stretch flex flex-col items-center justify-center relative shrink-0 w-full">
        <CompanyHeader name="ООО Герофарм" period="2015 - Present" tech={[".NET", "SharePoint", "React"]} />
        
        <PositionRow title="Рук. отдела" year={2021} />
        <PositionRow title="Teamlead" year={2018} />
        <PositionRow title="Senior" year={2016} />
        <PositionRow title="Middle" year={2015} />
      </div> */}

      {/* ООО Иттилан */}
      {/* <div className="content-stretch flex flex-col items-center justify-center relative shrink-0 w-full">
        <CompanyHeader name="ООО Иттилан" period="2012 - 2015" tech={[".NET", "SharePoint"]}/>
        
        <PositionRow title="Senior" year={2014} />
        <PositionRow title="Middle" year={2013} />
        <PositionRow title="Junior" year={2012} />
      </div> */}

      {/* Фриланс */}
      {/* <div className="content-stretch flex flex-col items-center justify-center relative shrink-0 w-full">
        <CompanyHeader name="Фриланс" period="2007 - 2012" tech={["PHP", "jQuery"]} secondary={true} />
      </div> */}
    </div>
  );
};

export default MiniCVSection;
